import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import cuetLive from "../images/cuetLive.webp";
import Google_play from "../images/google-play.webp";
import Payment from "../images/payment.webp";
import mobileFoot from "../images/mobile-footer.webp";
import footMail from "../images/foot-mail.webp";
import footlocation from "../images/foot-location.webp";

import footerIocn from "../images/footer-icon.png";

import { apiBaseURL, apiURL, apiKey } from "./../../../constant";
import { Contaxt } from "../../../Store";
import Loader from "../../../Loader";

const Footer = () => {
  const [curYear, setCurYear] = useState(new Date().getFullYear());
  const { footerData } = useContext(Contaxt);
  const [subscribeData, setSubscribeData] = useState({
    text: "",
    status: "",
    msg: ""
  });

  // Update current year every hour
  useEffect(() => {
    const interval = setInterval(() => {
      setCurYear(new Date().getFullYear());
    }, 3600000); // Check every hour
    return () => clearInterval(interval);
  }, []);

  function setDataForSubscribe(value, type) {
    setSubscribeData((prev) => ({ ...prev, [type]: value }));
  }

  function sendSubscription() {
    setSubscribeData((prev) => ({ ...prev, status: "loading" }));
    fetch(apiBaseURL + apiURL.subscribe, {
      method: "POST",
      headers: {
        rskey: apiKey
      },
      body: JSON.stringify({ EmailId: subscribeData.text })
    })
      .then((result) => result.json())
      .then((res) => {
        if (res.status === "1") {
          setSubscribeData((prev) => ({
            ...prev,
            status: "success",
            text: "",
            msg: res.message
          }));
        } else {
          setSubscribeData((prev) => ({
            ...prev,
            status: "success",
            msg: res.message
          }));
        }
      })
      .catch((err) => {
        console.error(err);
        setSubscribeData((prev) => ({
          ...prev,
          status: "success",
          msg: "Network Error."
        }));
      });
  }

  return (
    <div className="App">
      <footer>
        <div className="foot_section">
        <Col md={12} sm={12} className="text-center my-1">
          <img src={footerIocn} style={{ maxWidth: '100%' }}  alt="Student Icon"  loading="lazy"/>
        </Col>
          <Row>
            <Col md={8} sm={12}>
              <h2>We are always here to help you. Get in touch with us</h2>
              <div className="foot-nav">
                {/* Navigation links can be added here */}
              </div>
            </Col>
            <Col md={2} sm={12}>
              <div className="add-input">
                <input type="email" placeholder="Enter your email" value={subscribeData.text} onChange={(e) =>
                    setDataForSubscribe(e.target.value, "text")
                  }
                />
                {subscribeData.status === "success" && (
                  <small>{subscribeData.msg}</small>
                )}
              </div>
            </Col>
            <Col md={2} sm={12}>
              {subscribeData.status === "loading" ? (
                <div
                  className="btn-submit"
                  style={{ position: "relative", height: "60px" }}
                >
                  <Loader
                    width="35px"
                    height="35px"
                    backgroundColor="transparent"
                  />
                </div>
              ) : (
                <div className="btn-submit">
                  <button
                    className="btn-sub"
                    type="button"
                    onClick={sendSubscription}
                  >
                    Submit
                  </button>
                </div>
              )}
            </Col>

            <Col md={3} sm={6}>
              <div className="footer_links">
                <h3>Product & Services</h3>
                <ul>
                  {footerData.productServices.map((item) => (
                    <li key={item.id}>
                      <Link to={item.slug}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className="footer_links">
                <h3>Terms of Use</h3>
                <ul>
                  {footerData.termUses.map((item) => (
                    <li key={item.id}>
                      <Link to={item.slug}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className="footer_links">
                <h3>Login</h3>
                <ul>
                  {footerData.loginData.map((item) => (
                    <React.Fragment key={item.id}>
                      {item.urlType === "internal" ? (
                        <li>
                          <Link to={item.slug}>{item.title}</Link>
                        </li>
                      ) : (
                        <li>
                          <a
                            href={item.slug}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.title}
                          </a>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className="footer_links">
                <h3>Contact Us</h3>
                <div className="row">
                  <div className="col-md-2 col-sm-2 col-2">
                    <div className="link-address">
                      <a href="#">
                        <img
                          src={mobileFoot}
                          alt="Mobile"
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    </div>
                    <div className="link-address">
                      <a href="#">
                        <img
                          src={footMail}
                          alt="Email"
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    </div>
                    <div className="link-address">
                      <a href="#">
                        <img
                          src={footlocation}
                          alt="Location"
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-10 col-sm-10 col-10">
                    <div className="address">
                      +91-11-43585858 <br /> 23285568
                    </div>
                    <div className="address">info@rachnasagar.in</div>
                    <div className="address">
                      4583/15, Daryaganj, <br /> New Delhi – 110002, INDIA
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="foot_img_section">
          <Row>
            <Col md={6} sm={6}>
              <div className="follow">
                <h4>Follow Us</h4>
                <div className="item-social">
                  {footerData.socialItems.map((item) => (
                    <div className="team-facebook" key={item.url}>
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={item.image}
                          alt={item.alt_title}
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className="payment-m">
                <h4>Try Our App</h4>
                <div className="foot_img">
                  <div className="foot-img-center">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://play.google.com/store/apps/details?id=com.rachnasagar&amp;hl=en_IN"
                    >
                      <img
                        src={Google_play}
                        alt="Google Play"
                        loading="lazy"
                        decoding="async"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className="payment-m">
                <h4>Payment Methods</h4>
                <div className="foot_img_pay">
                  <img
                    className="payment"
                    src={Payment}
                    alt="Payment Methods"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {/* CHAT BOX SECTION */}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://wa.aisensy.com/QEsnfY"
        >
          <div className="open-button">
            <i className="fa fa-whatsapp smilefa" aria-hidden="true"></i>{" "}
            Chat with us
          </div>
        </a>
        {/* FOOTER BOTTOM */}
        <div className="foot-buttom">
          <p>© 1995 - {curYear} Rachna Sagar Pvt. Ltd. All rights reserved.</p>
        </div>
        {/* Cute section */}
        <div className="cuet">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://cuet.rachnasagar.in/"
          >
            <img
              className="stickerImg"
              src={cuetLive}
              alt="Cuet Live"
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
        {/* Cute section */}
      </footer>
    </div>
  );
};

export default Footer;
